import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from "redux";
import ReportsListTable from './ReportsListTable';
import { ReportAdministrationView, ReportOpeningState } from './ReportsState';
import { SSRSCredential } from '../misc/api/apiTypes';
import { Folder } from '../misc/api/ReportsApiTypes';
import Alert, { AlertCategoryEnum } from '../misc/components/Alert';
import { GetCredentialsAsyncAction, TestConnectionAsyncAction, GetReportRolesAsyncAction, GetSelectedRootFolderAction, GetFoldersAsyncAction } from './Administration/AdministrationActions';
import LoadingWithMessage from '../misc/components/LoadingWithMessage';
import { MainState } from "../Core/reducers";
import { useCurrentStudyConfigurationContext } from '../Core/CurrentStudyConfigurationContext';
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../misc/api/WebPortalTokenClient';
import { useSecurityContext } from '../Core/SecurityContext';
import { ODataParams, Query } from '../Components/Query';
import { PermissionEnum } from '../misc/api/ApiPermissionEnum';
import { useNavigate } from 'react-router-dom';

export interface ReportsAppProps {
    reportOpening: ReportOpeningState;

    isConnectedToReportServer: boolean;
    availableFolders: Array<Folder>;
    currentAdministrationView: ReportAdministrationView;
    defaultCredentials: SSRSCredential;
    dispatch?: Dispatch<MainState>;
    showReportModal: boolean;
    selectedReportId?: string;
}

export interface ReportsAppState {
    showReportModal: boolean;
}

export const ReportsApp = (props: ReportsAppProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();
    const navigate = useNavigate();
    const [redirected, setRedirected] = React.useState<boolean>(false);

    const { currentUserPermissions, currentUser } = useSecurityContext();

    React.useEffect(() => {
        props.dispatch(GetCredentialsAsyncAction.create(legacyClient));
        props.dispatch(TestConnectionAsyncAction.create(legacyClient));
        props.dispatch(GetFoldersAsyncAction.create(legacyClient));
        props.dispatch(GetReportRolesAsyncAction.create(client.client));
        props.dispatch(GetSelectedRootFolderAction.create(legacyClient));
    }, []);


    React.useEffect(() => {
        if (props.defaultCredentials?.ServerType == 2 && !redirected && props.availableFolders) {
            setRedirected(true);
            legacyClient.getStudySelectedRootFolder().then((selectedFolderId) => {
                const selectedStudyRootFolderName = props.availableFolders?.find(e => e.Id == selectedFolderId)?.Name

                var redirectUrl = props.defaultCredentials.ServerURL + "/reportserver/logon.aspx?ReturnUrl=" + encodeURI('/Reports/browse/' + selectedStudyRootFolderName)
                window.open(redirectUrl, "_blank");
                navigate(-1);
            })
        }
    }, [props.defaultCredentials?.ServerType, props.availableFolders])

    const handleRefresh = async (params: ODataParams) => {
        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `studyIds/any(s: s eq ${study.id})`;

        if (!currentUserPermissions.some(e => e.Id === PermissionEnum.ViewReports))
            filter += `and rolesIds/any(r: r in (${currentUser.Roles.map(e => e.Id).join(',')}))`;

        return await client.client.getDefinedReports(undefined, filter, params.orderby, undefined, params.top, params.skip, undefined, true);
    }

    const renderListTable = () => {
        if (props.isConnectedToReportServer === null) {
            return (<LoadingWithMessage message="Connecting to Report Server..." />);
        } else {
            return <Query onRefresh={handleRefresh} initialOrdering={[{ field: "name", condition: "asc" }]}><ReportsListTable /></Query>;
        }
    }



    return (
        <>
            {renderListTable()}
        </>
    );
}

function mapStateToProps(state: MainState): ReportsAppProps {
    return {
        reportOpening: state.reports.listTable.reportOpening,
        isConnectedToReportServer: state.reports.administration.isConnectedToReportServer,
        defaultCredentials: state.reports.administration.credentials,
        availableFolders: state.reports.administration.availableFolders ? state.reports.administration.availableFolders.Data : null,
        currentAdministrationView: state.reports.administration.currentView,
        showReportModal: state.reports.listTable.showReportModal,
        selectedReportId: state.reports.listTable.selectedReportId
    }
}

export default connect<ReportsAppProps, any, {}>(mapStateToProps)(ReportsApp);
